import { Alert, Button, ExternalLink, Text } from '@ui/themed';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { featureRestricted, features, getActiveBillingPlanKey } from '../../../constants/features';
import { useEnv } from '../../../context/env-context';
import { useHandlers, useSite } from '../../../context/page-context';
import { trackUpgradeClicked } from '../../../lib/mixpanel';
import { DOCS_URLS, I18N_COMPONENTS } from '../constants';

export function StockLocationsUpsell() {
  const env = useEnv();
  const site = useSite();
  const { navigationHandler } = useHandlers();

  const activePlan = getActiveBillingPlanKey(env.billing.plan_key);
  const restricted = featureRestricted(features.MULTI_STOCK_LOCATION_SUPPORT, activePlan);

  return (
    <Alert variant="info" headingLevel="h3">
      <div className="flex w-full flex-col gap-2">
        <Text size="md" variant="primary">
          {t(`${I18N_COMPONENTS}.stock_locations_upsell.title`)}
        </Text>
        <Text variant="secondary">
          <Trans
            ns="features"
            i18nKey="products.components.stock_locations_upsell.description"
            components={{
              link: (
                <ExternalLink link={DOCS_URLS.stockLocations}>
                  {t(`${I18N_COMPONENTS}.stock_locations_upsell.stock_locations_link`)}
                </ExternalLink>
              ),
            }}
          />
        </Text>
        {restricted ? (
          <Button
            variant="secondary"
            onClick={() => {
              trackUpgradeClicked(site, 'Stock Locations');
              navigationHandler.navigateById('plan');
            }}
          >
            {t(`${I18N_COMPONENTS}.stock_locations_upsell.change_plan`)}
          </Button>
        ) : (
          <Button variant="secondary" onClick={() => navigationHandler.navigate('/customers')}>
            {t(`${I18N_COMPONENTS}.stock_locations_upsell.get_started`)}
          </Button>
        )}
      </div>
    </Alert>
  );
}
